const routes = [
    {
        path: "/curriculums",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "curriculum_index"
        }
    }
];

export default routes;
